import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core'

import { id, timestamps } from './_columns'
import type { StaffRole } from '../contracts'

/** Console staff: the people who run the platform (not the customers' CMS users). */
export const staff = sqliteTable(
  'staff',
  {
    id: id(),
    email: text('email').notNull().unique(),
    name: text('name').notNull(),
    role: text('role').$type<StaffRole>().notNull().default('support'),
    /** PBKDF2-SHA256 — `pbkdf2$<iterations>$<salt b64>$<hash b64>` (same format as the CMS). */
    passwordHash: text('password_hash').notNull(),
    active: integer('active', { mode: 'boolean' }).notNull().default(true),
    failedLoginCount: integer('failed_login_count').notNull().default(0),
    lockedUntil: text('locked_until'),
    lastLoginAt: text('last_login_at'),
    ...timestamps,
  },
  (t) => [index('ix_staff_active').on(t.active)],
)

export const staffSessions = sqliteTable(
  'staff_sessions',
  {
    /** SHA-256 of the session token; the raw token only ever lives in the cookie. */
    id: text('id').primaryKey(),
    staffId: text('staff_id').notNull(),
    expiresAt: text('expires_at').notNull(),
    userAgent: text('user_agent'),
    createdAt: timestamps.createdAt,
  },
  (t) => [index('ix_staff_sessions_staff_id').on(t.staffId), index('ix_staff_sessions_expires_at').on(t.expiresAt)],
)
